const dom = require('../utils/DOM');
const Callback = require('../classes/Callback');

function Router() {
	this._routes = [];

	this._cachedIndex = window.history.length;
	this._lastDirection = 1;

	this._hashDelimeter = '!/';

	this._canUseHistory = !!(window.history && window.history.pushState);

	var href = document.location.href;
	if (href.indexOf('192.168') != -1) {
		this._origin = 'http://192.168.1.7:9000';
		this._canUseHistory = false;
		this._mode = 0;
	} else if (href.indexOf('localhost') != -1) {
		this._origin = 'http://localhost:9000';
		this._canUseHistory = true;
		this._mode = 1;
	} else {
		//var locationOrigin = window.location.origin;
		var dataOrigin = dom.$body.attr('data-origin');
		//var metaOrigin = $('meta[property="og:url"]').attr('content');

		if (this._checkOriginToLocation(dataOrigin)) {
			this._origin = dataOrigin;

			this._mode = 3;
			//} else if (this._checkOriginToLocation(metaOrigin)) {
			//    this._origin = metaOrigin;
		} else {
			this._mode = 4;

			var locationOrigin = window.location.origin;
			this._origin = locationOrigin
				? locationOrigin
				: window.location.protocol +
				  '//' +
				  window.location.hostname +
				  (window.location.port ? ':' + window.location.port : '');
		}

		//this._origin = locationOrigin ? locationOrigin : window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	}

	if (this._canUseHistory) {
		href = href.split('#')[0];
	}

	this._location = href;

	var self = this;
	if (this._canUseHistory) {
		window.onpopstate = function(e) {
			self._lastDirection = 1;
			if (e && e.state && e.state.index) {
				if (e.state.index < self._cachedIndex) {
					self._lastDirection = -1;
				}
				self._cachedIndex = e.state.index;
			}
			self._checkAddressChange();
		};

		window.history.scrollRestoration = 'manual';
	} else {
		setInterval(function() {
			self._checkAddressChange();
		}, 150);
	}

	this.onChange = new Callback();
}

Router.prototype = {
	getOrigin: function() {
		return this._origin;
	},
	_checkAddressChange: function() {
		if (document.location.href != this._location) {
			this._location = document.location.href;
			this._handleChange();
		}
	},

	_checkOriginToLocation: function(origin) {
		return (
			typeof origin != 'undefined' &&
			origin != '' &&
			document.location.href.split(origin).length > 1
		);
	},

	_removeTrailingSlashes: function(string) {
		string = string || '';
		while (string.substr(0, 1) == '/') {
			string = string.substr(1);
		}

		while (string.substr(-1) == '/') {
			string = string.substr(0, string.length - 1);
		}

		return string;
	},

	_removeStringPart: function(string, part) {
		var splitted = string.split(part);
		return splitted[splitted.length - 1];
	},

	_removeOrigin: function(string) {
		return this._removeStringPart(string, this._origin);
	},

	_removeHashDelimeter: function(string) {
		return this._removeStringPart(string, this._hashDelimeter);
	},

	_removeExtraSlashes: function(string) {
		return string.replace(/\/\/+/g, '/');
	},

	_testIndexHref: function(string) {
		return string == '' ? '/' : string;
	},

	_handleChange: function(skipCallChange) {
		var newAddress = this.get();
		newAddress = newAddress == '/' ? newAddress : '/' + newAddress + '/';

		var totalRoutes = this._routes.length;

		for (var k = 0; k < totalRoutes; k++) {
			var route = this._routes[k];
			var match = newAddress.match(route.re);
			if (match) {
				match.shift();
				route.handler.apply(route.scope, match);
			}
		}

		if (!skipCallChange) {
			this.onChange.call();
		}
	},

	set: function(address, skipCallChange, overwrite) {
		address = this._removeOrigin(address);
		address = this._removeTrailingSlashes(address);
		address = this._removeExtraSlashes(address);

		var fullAddress = this._origin + '/' + address;

		if (fullAddress == document.location.href) {
			return;
		}

		if (this._canUseHistory) {
			this._lastDirection = 1;

			if (overwrite) {
				window.history.replaceState({ index: this._cachedIndex }, null, fullAddress);
			} else {
				this._cachedIndex++;
				window.history.pushState({ index: this._cachedIndex }, null, fullAddress);
			}

			this._location = fullAddress;
		} else {
			document.location.hash = this._hashDelimeter + address;

			this._location = document.location.href;
		}

		if (!skipCallChange) {
			this._handleChange();
		}
	},

	get: function() {
		if (this._checkLocation != this._location) {
			this._checkLocation = this._location;

			if (this._canUseHistory) {
				this._getResult = this._removeTrailingSlashes(this._removeOrigin(this._location));
			} else {
				this._getResult = this._removeTrailingSlashes(
					this._removeHashDelimeter(this._removeOrigin(this._location))
				);
			}

			this._getResult = this._testIndexHref(this._getResult);
		}

		return this._getResult;
	},

	getDirection: function() {
		return this._lastDirection;
	},

	getParts: function() {
		var address = this.get();
		return address == '/' ? [] : address.split('/');
	},

	testHrefIsActual: function(href) {
		if (typeof href == 'undefined') {
			return false;
		}

		href = this._removeOrigin(href);
		href = this._removeTrailingSlashes(href);
		href = this._removeExtraSlashes(href);
		href = this._testIndexHref(href);

		return href == this.get();
	},

	testHrefIsExternal: function(url) {
		var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/); // eslint-disable-line
		if (
			typeof match[1] === 'string' &&
			match[1].length > 0 &&
			match[1].toLowerCase() !== location.protocol
		)
			return true;
		if (
			typeof match[2] === 'string' &&
			match[2].length > 0 &&
			match[2].replace(
				new RegExp(':(' + { 'http:': 80, 'https:': 443 }[location.protocol] + ')?$'),
				''
			) !== location.host
		)
			return true;
		return false;
	},

	update: function() {
		this._handleChange();
	},

	add: function(re, handler, scope) {
		this.remove(re, handler);
		this._routes.push({
			re: re,
			handler: handler,
			scope: scope,
		});
		return this;
	},

	remove: function(re, handler) {
		var totalRoutes = this._routes.length;
		for (var k = 0; k < totalRoutes; k++) {
			if (this._routes[k].re == re) {
				if (this._routes[k].handler == handler) {
					this._routes.splice(k, 1);
					return this;
				}
			}
		}

		return this;
	},
};

module.exports = new Router();
